// src/components/AdUnit.js
// A manually-placed AdSense display ad unit (created in the AdSense
// dashboard, not Auto ads). Unlike Auto ads, this only ever renders exactly
// where we put it in the JSX - no risk of it deciding on its own to cover
// the keyboard or the board.
import React, { useEffect, useRef } from 'react';

function AdUnit({ slot, format = 'auto', fullWidthResponsive = true, style, className }) {
  const pushedRef = useRef(false);

  useEffect(() => {
    // Each <ins> must be push()'d exactly once. Guards against StrictMode's
    // double-invoke in dev and against firing twice if this effect somehow
    // re-runs without a real remount.
    if (pushedRef.current) return;
    pushedRef.current = true;
    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
    } catch (e) {
      console.error('AdUnit: push failed', e);
    }
  }, []);

  return (
    <ins
      className={`adsbygoogle${className ? ` ${className}` : ''}`}
      style={style || { display: 'block' }}
      data-ad-client="ca-pub-5052222576952627"
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={fullWidthResponsive ? 'true' : 'false'}
    />
  );
}

export default AdUnit;
